export default "__VITE_ASSET__8e521568__"